module.exports = __webpack_public_path__ + "static/media/alerts_icon_alert.ddb32671.svg";